export const isDesktopFilter = () => {
  // detect touch events so we know if we are on a mobile or mobile-like device
  return !('ontouchstart' in window) && window.innerWidth > 768;
};
